<h2 mat-dialog-title>Tag this review</h2>


<mat-dialog-content class="flex flex-col gap-4 w-full">

  @if (errorMessage) {
    <div class="text-sm text-red-600">{{ errorMessage }}</div>
  }


  <mat-form-field appearance="outline" class="flex-1 w-full">
    <mat-label >Tags</mat-label>
    <mat-select
      class="w-full"
      [formField]="updateForm.labelIds"
      multiple>
      @for (label of labels; track label.id ?? $index) {
        @if (label.id !== undefined) {
          <mat-option [value]="label.id" >
            {{ label.name }}
          </mat-option>
        }
      }
    </mat-select>
  </mat-form-field>

  @if (loadingTagForm()) {
    <mat-progress-bar mode="indeterminate"></mat-progress-bar>
  }
</mat-dialog-content>

<mat-dialog-actions class="gap-2">
  <app-button variant="primary" (btnClick)="save()">
    Save
  </app-button>

  <app-button variant="outline" (btnClick)="close()">
    Cancel
  </app-button>
</mat-dialog-actions>
